import React from 'react';
import { useSelector } from 'react-redux';
import { Redirect, Route } from 'react-router-dom';
import { ERoutes } from '../../routes';
import { ApplicationState } from '../../store';
import { ECustomerTypeView } from '../../store/ducks/user/types';
import Fabrication from './Fabrication';
import SteelTypeChoose from './SteelTypeChoose';
import LongSteelRoutes from './LongSteel';
import PurchaseHome from './PurchaseHome';
import { GetFlag } from '../../utils/featureFlag';

export enum EPurchaseRoutes {
  STEEL_TYPE_CHOOSE = 'steel-type-choose',
  LONG_STEEL = 'long-steel',
  FABRICATION = 'fabrication', // corte e dobra
  COMMERCE = 'commerce',
  CHECKOUT = 'checkout'
}

const PurchaseRoutes: React.FC = () => {
  const JOURNEYVIEW_TYPE = 'commerce_magento';
  const path = `${ERoutes.PURCHASE}`;
  const journeyViews = useSelector(
    (appState: ApplicationState) => appState.user.journeyViews
  );
  const customerViewType = useSelector(
    (appState: ApplicationState) => appState.user.searchCustomerType
  );
  const hasUserFabricationAccess = useSelector(
    (appState: ApplicationState) =>
      appState.user.userPermissions.hasFabricationAccess
  );
  const newPurchaseFlag = GetFlag('jornada_compras');

  const isEmitter = customerViewType === ECustomerTypeView.EMITTER;
  const isFabricationReceiver =
    customerViewType === ECustomerTypeView.FABRICATION_RECEIVER;
  const isMVPUser = journeyViews && journeyViews.includes(JOURNEYVIEW_TYPE); // Aqui a regra verifica o primeiro elemento no array, mas podemos usar também o array.includes

  const MVPRoutes = () => {
    return (
      <>
        <Route path={`${path}/`} exact>
          <Redirect
            to={`${path}/${EPurchaseRoutes.COMMERCE}/${EPurchaseRoutes.STEEL_TYPE_CHOOSE}`}
          />
        </Route>

        <Route path={`${path}/${EPurchaseRoutes.STEEL_TYPE_CHOOSE}`}>
          <Redirect
            to={`${path}/${EPurchaseRoutes.COMMERCE}/${EPurchaseRoutes.STEEL_TYPE_CHOOSE}`}
          />
        </Route>

        <Route
          path={`${path}/${EPurchaseRoutes.COMMERCE}/${EPurchaseRoutes.STEEL_TYPE_CHOOSE}`}
          component={PurchaseHome}
        />

        <Route
          path={`${path}/${EPurchaseRoutes.FABRICATION}`}
          component={Fabrication}
        />

        <Route
          path={`${path}/${EPurchaseRoutes.LONG_STEEL}`}
          component={LongSteelRoutes}
        />
      </>
    );
  };

  const NonMvpRoutes = () => {
    return (
      <>
        <Route path={`${path}/`} exact>
          <Redirect to={`${path}${''}/${EPurchaseRoutes.STEEL_TYPE_CHOOSE}`} />
        </Route>

        <Route
          path={`${path}/${EPurchaseRoutes.COMMERCE}/${EPurchaseRoutes.STEEL_TYPE_CHOOSE}`}
        >
          <Redirect to={`${path}/${EPurchaseRoutes.STEEL_TYPE_CHOOSE}`} />
        </Route>

        <Route
          path={`${path}${''}/${EPurchaseRoutes.STEEL_TYPE_CHOOSE}`}
          component={SteelTypeChoose}
        />

        <Route
          path={`${path}${''}/${EPurchaseRoutes.FABRICATION}`}
          component={Fabrication}
        />

        <Route
          path={`${path}/${EPurchaseRoutes.LONG_STEEL}`}
          component={LongSteelRoutes}
        />
      </>
    );
  };

  return (
    <>
      {/* Rotas de compra de aços longos */}
      {isEmitter && isMVPUser && (
        <>{newPurchaseFlag ? <MVPRoutes /> : <NonMvpRoutes />}</>
      )}
      {hasUserFabricationAccess && isEmitter && !isMVPUser && <NonMvpRoutes />}

      {/* Rotas de corte e dobra */}
      {hasUserFabricationAccess && isFabricationReceiver && (
        <>
          <Route path={`${path}/`} exact>
            <Redirect to={`${path}${''}/${EPurchaseRoutes.FABRICATION}`} />
          </Route>

          <Route
            path={`${path}${''}/${EPurchaseRoutes.FABRICATION}`}
            component={Fabrication}
          />
        </>
      )}
      {/* Rotas de usuários sem acesso a corte e dobra */}
      {!hasUserFabricationAccess && isEmitter && !isMVPUser && (
        <>
          <Route path={`${path}/`} exact>
            <Redirect to={`${path}/${EPurchaseRoutes.LONG_STEEL}`} />
          </Route>

          <Route
            path={`${path}${''}/${EPurchaseRoutes.STEEL_TYPE_CHOOSE}`}
            exact
          >
            <Redirect to={`${path}/${EPurchaseRoutes.LONG_STEEL}`} />
          </Route>

          <Route
            path={`${path}/${EPurchaseRoutes.LONG_STEEL}`}
            component={LongSteelRoutes}
          />
        </>
      )}
    </>
  );
};

export default PurchaseRoutes;
